import { DialogTrigger } from 'react-aria-components';
import { useTranslation } from 'react-i18next';
import { Link } from 'wouter';
import DateTime from '~/components/DateTime';
import Money from '~/components/Money';
import Button from '~/components/ui/Button';
import { InnerCard } from '~/components/ui/Card';
import { SkeletonCard } from '~/components/ui/Skeleton';
import useActiveSubscription from '~/modules/subscription/useActiveSubscription';
import useSubscriptionPlans from '~/modules/subscription/useSubscriptionPlans';
import SwitchPlanDialog from './SwitchPlanDialog';

function SwitchPlanBlock() {
  const { t } = useTranslation('', { keyPrefix: 'subscription.plan' });
  const { data: activePlan, isLoading } = useActiveSubscription();
  const plans = useSubscriptionPlans();

  return (
    <>
      {isLoading ? (
        <SkeletonCard height={114} />
      ) : (
        <InnerCard title={t('title')}>
          <div className="flex-1 flex justify-between items-start">
            {activePlan ? (
              <div>
                <div className="font-bold mb-2">
                  {activePlan.plan_name} / <Money value={activePlan.plan_price} />
                </div>
                {activePlan.is_renewable && (
                  <div className="text-body text-xs leading-5">
                    {t('billingPeriod', { days: activePlan.plan_duration })}
                  </div>
                )}
                {!activePlan.is_renewable && (
                  <div className="text-body text-xs leading-5">{t('notRenewable')}</div>
                )}
                <div className="text-body text-xs leading-5">
                  {t('startDate')}: <DateTime as="span" value={activePlan.start_date} />
                </div>
                <div className="text-body text-xs leading-5">
                  {t('endDate')}: <DateTime as="span" value={activePlan.end_date} />
                </div>
              </div>
            ) : (
              <div className="font-bold self-center">{t('free')}</div>
            )}

            {plans && plans.length > 1 && (
              <DialogTrigger>
                <Button size="sm" variant="outlined">
                  {t('switchPlan')}
                </Button>
                <SwitchPlanDialog />
              </DialogTrigger>
            )}
          </div>

          {activePlan?.is_renewable && (
            <div>
              <div className="border-t-1 border-t-card-border my-4" />
              <div className="text-right">
                <DialogTrigger>
                  <Link
                    className="text-destruction text-sm font-semibold"
                    to="/subscription/cancel"
                  >
                    {t('cancelSubscription')}
                  </Link>
                </DialogTrigger>
              </div>
            </div>
          )}
        </InnerCard>
      )}
    </>
  );
}

export default SwitchPlanBlock;
